
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
  },
  props: {
    text: String,
  }
})
export default class SoundSubTitles extends Vue {
  text!: string;

  get captions() {
    if (this.text == undefined)
      return [];

    return this.text.split('\n');
  }
}
